<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { getMessaging, getToken } from 'firebase/messaging'
import Backend from '@/models/backend.ts'
import { ref } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useNewsStore } from '@/stores/newsStore.ts'
import NewsNotificationDevice from '@/components/Sections/News/Notifications/Devices/NewsNotificationDevice.vue'
import { logger } from '@/models/logger';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores
 */
const gameStore = useGameStore()
const newsStore = useNewsStore()

/**
 * Variables
 */
const errorMessage = ref('');
const messaging = getMessaging();

/**
 * Functions
 */
async function requestPermissionAndGetToken() {
  errorMessage.value = ''
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      const currentToken = await getToken(messaging, {
        vapidKey: 'BEHw7ok0SL3e4Nv3ZYbT3foyiZGeTvVcKi4t9KQ7-kHg6sutrL44Z7QyS7RItIjC5b_7d_NWrXmFkDLi2u8pVIk'
      })

      if (currentToken) {
        const backend = new Backend()
        await backend.postFireBaseToken(currentToken).then(() => {
          gameStore.setTinySuccessToastMessage(t('notifications.success.deviceAdded'))
        })
      } else {
        errorMessage.value = t('news.notifications.devices.noToken')
      }
    } else {
      errorMessage.value = t('news.notifications.devices.permissionDenied')
    }
  } catch (err) {
    logger.error('Error retrieving token:', err)
    errorMessage.value = t('news.notifications.devices.tokenError')
  }
}
</script>

<template>
  <div>
    <StandardCard :title="t('news.notifications.devices.receiveTitle')">
      <div>
        <p class="pb-2">{{ t('news.notifications.devices.receiveDescription') }}</p>
        <ActionButton @click="requestPermissionAndGetToken">{{ t('news.notifications.addNewDevice') }}</ActionButton>
        <div class="pt-2 text-red-500" v-if="errorMessage">{{errorMessage}}</div>
      </div>
    </StandardCard>
    <StandardCard v-if="newsStore.firebaseTokens.size>0" :title="t('news.notifications.devices.registeredTitle')" :no-padding="true">
      <div class="pt-2 px-2">
        <template v-for="token in newsStore.firebaseTokens.values()" :key="token.id">
          <NewsNotificationDevice :id="token.id" :name="token.name"/>
        </template>
      </div>
    </StandardCard>
  </div>
</template>

<style scoped lang="scss">

</style>